import {Model} from './Model';
import {TicketConfiguration} from './TicketConfiguration';
import {UUID4Utility} from '../Utilities';

export class TicketConfigurationCollection extends Model {
  public ticketConfigurations: Array<TicketConfiguration> = [];
  public quantity: number = 0;

  constructor() {
    super({id: ''});
  }

  get maxQuantity(): number {
    let maxQuantity = 0;
    this.ticketConfigurations.forEach((ticketConfiguration) => {
      if (ticketConfiguration.slot) {
        maxQuantity += ticketConfiguration.slot.quota;
      }
    });
    return maxQuantity;
  }

  get hasProductFamilies(): boolean {
    let hasProductFamilies: boolean = false;
    for (const ticketConfig of this.ticketConfigurations) {
      if (ticketConfig.subTicketConfigurations.length > 0) {
        hasProductFamilies = true;
        break;
      }
    }
    return hasProductFamilies;
  }

  addTicketConfiguration(ticketConfiguration: TicketConfiguration) {
    this.ticketConfigurations.push(ticketConfiguration);
  }

  resetIds() {
    for (const ticketConf of this.ticketConfigurations) {
      ticketConf.resetIds();
    }
  }

  toString(): string {
    return `TicketConfigurationCollection<${this.quantity}>`;
  }
}
